'use client'
import React from 'react'

import {
  MediaSettingsMenu,
  MediaSettingsMenuItem
} from 'media-chrome/react/menu'

import { playerSettingMenuItems } from '@/app/constants/const'

export default function MediaSettingsMenuComponent ({
  ...props
}) {
  const isAudioSettings = props.controls?.audioSettings || false
  const renderMenuItem = (item, index) => (
    <MediaSettingsMenuItem key={index}>
      {item.title}
      {item.submenu}
    </MediaSettingsMenuItem>
  )
  const playerSettings = playerSettingMenuItems(props.language)
  return (
    <MediaSettingsMenu hidden anchor='auto'>
      {/* // if props.captionList is empty then hide the caption menu */}
      {/* // here we are checking the captionList is empty or not and don    */}
      {playerSettings.map((item, index) => {
        if (item.name === 'captions' && props?.captionList?.length === 0) return null // hide captions if captionList is empty
        if (item.name === 'audio' && !isAudioSettings) return null // hide audio settings if audioSettings is false
        return renderMenuItem(item, index)
      })}
    </MediaSettingsMenu>
  )
}
